// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import Turbolinks from 'turbolinks';
import * as ActiveStorage from "@rails/activestorage";
import "channels";

Rails.start()
Turbolinks.start();
ActiveStorage.start();

//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
////  Mandatory Plugins Includes(do not remove or change order!)  ////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////

// Jquery - jQuery is a popular and feature-rich JavaScript library. Learn more: https://jquery.com/
window.jQuery = window.$ = require('jquery');

// Bootstrap - The most popular framework uses as the foundation. Learn more: http://getbootstrap.com
window.bootstrap = require('bootstrap');

// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
window.Popper = require('@popperjs/core');

// Wnumb - Number & Money formatting. Learn more: https://refreshless.com/wnumb/
// window.wNumb = require('wnumb');

// Moment - Parse, validate, manipulate, and display dates and times in JavaScript. Learn more: https://momentjs.com/
window.moment = require('moment');

// ES6-Shim - ECMAScript 6 compatibility shims for legacy JS engines.  Learn more: https://github.com/paulmillr/es6-shim
require("es6-shim/es6-shim.min.js");

// Keenthemes' plugins
window.KTUtil = require('../components/util.js');
window.KTBlockUI = require('../components/blockui.js');
window.KTCookie = require('../components/cookie.js');
window.KTDialer = require('../components/dialer.js');
window.KTDrawer = require('../components/drawer.js');
window.KTEventHandler = require('../components/event-handler.js');
window.KTFeedback = require('../components/feedback.js');
window.KTImageInput = require('../components/image-input.js');
window.KTMenu = require('../components/menu.js');
window.KTPasswordMeter = require('../components/password-meter.js');
window.KTScroll = require('../components/scroll.js');
window.KTScrolltop = require('../components/scrolltop.js');
window.KTSearch = require('../components/search.js');
window.KTStepper = require('../components/stepper.js');
window.KTSticky = require('../components/sticky.js');
window.KTSwapper = require('../components/swapper.js');
window.KTToggle = require('../components/toggle.js');

// Layout base js
window.KTApp = require('../layout/app.js');
window.KTLayoutExplore = require('../layout/explore.js');
window.KTLayoutSearch = require('../layout/search.js');


import('jquery');
import "popper.js";
import "bootstrap";
import "smooth-scroll";
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';

global.$ = jQuery;

// custom
require('../custom/forms.js')
require('../custom/charts.js')
require('../custom/charts/burndown.js')
require('../custom/charts/velocity.js')
require('../custom/charts/burnup.js')
require('../custom/charts/custom_chart.js')
require('../custom/charts/scrum_charts.js')
require('../custom/dashboards.js')
require('../custom/general.js')
require('../custom/users.js')
require('../custom/projects.js')
require('../custom/reports.js')
require('../custom/pages/pricing/general.js')
require('../custom/abraham.js')

// window.BalloonEditor = require('@ckeditor/ckeditor5-build-balloon/build/ckeditor.js');

window.toastr = require('../../assets/plugins/toastr/build/toastr.min.js');